import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CallToAction = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-slate-100 to-slate-200 dark:from-primary dark:to-primary/80">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-6">
            Ready to Build Something Amazing?
          </h2>
          
          <p className="text-xl text-slate-700 dark:text-white/95 mb-8 max-w-2xl mx-auto">
            Let's collaborate on your next project. I'm passionate about creating innovative solutions 
            that drive business growth and deliver exceptional user experiences.
          </p>
        </div>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Link to="/contact">
            <Button 
              variant="secondary" 
              size="lg" 
              iconName="MessageCircle" 
              iconPosition="left"
              className="w-full sm:w-auto bg-primary text-white hover:bg-primary/90 dark:bg-white dark:text-primary dark:hover:bg-white/90"
            >
              Start a Conversation
            </Button>
          </Link>
          
          <Link to="/projects">
            <Button 
              variant="outline" 
              size="lg" 
              iconName="Eye" 
              iconPosition="left"
              className="w-full sm:w-auto border-primary text-primary hover:bg-primary hover:text-white dark:border-white/80 dark:text-white dark:hover:bg-white dark:hover:text-primary"
            >
              View My Work
            </Button>
          </Link>
        </div>
        
        {/* Contact Methods */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-primary/20 dark:bg-white/30 rounded-full flex items-center justify-center mb-3">
              <Icon name="Mail" size={24} className="text-primary dark:text-white" />
            </div>
            <h3 className="font-semibold mb-1 text-slate-900 dark:text-white">Email</h3>
            <a 
              href="mailto:contact.dishantpatel@gmail.com" 
              className="hover:underline transition-colors text-slate-700 dark:text-white/95 break-all"
            >
              contact.dishantpatel@gmail.com
            </a>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-primary/20 dark:bg-white/30 rounded-full flex items-center justify-center mb-3">
              <Icon name="Phone" size={24} className="text-primary dark:text-white" />
            </div>
            <h3 className="font-semibold mb-1 text-slate-900 dark:text-white">Phone</h3>
            <a 
              href="tel:+1234567890" 
              className="hover:underline transition-colors text-slate-700 dark:text-white/95"
            >
              +91 814-147-5777
            </a>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-primary/20 dark:bg-white/30 rounded-full flex items-center justify-center mb-3">
              <Icon name="MapPin" size={24} className="text-primary dark:text-white" />
            </div>
            <h3 className="font-semibold mb-1 text-slate-900 dark:text-white">Location</h3>
            <span className="text-slate-700 dark:text-white/95">Surat, IN</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;